<!-- Normal mode (inline) -->
@if (!isFloating) {
<div class="language-switcher">
    <button type="button"
        (click)="setLang('es')"
        [class.active]="isActive()('es')"
        class="lang-button"
    >
        🇪🇸 Español
    </button>
    <button type="button"
        (click)="setLang('en')"
        [class.active]="isActive()('en')"
        class="lang-button"
    >
        🇬🇧 English
    </button>
</div>
}

<!-- Floating mode -->
@if (isFloating) {
<div class="floating-lang-switcher">
    <!-- The flag emoji is the only visible content, so without a label the
         button announced itself as "🇪🇸" and nothing else. -->
    <button type="button"
        class="floating-toggle-btn"
        (click)="toggleFloatingMenu()"
        [class.open]="isFloatingMenuOpen()"
        [attr.aria-label]="'layout.language.change' | transloco"
        [attr.aria-expanded]="isFloatingMenuOpen()"
        aria-haspopup="menu"
    >
        <span class="current-flag" aria-hidden="true">{{ getCurrentFlag() }}</span>
        <i class="pi pi-chevron-down" [class.rotated]="isFloatingMenuOpen()" aria-hidden="true"></i>
    </button>

    @if (isFloatingMenuOpen()) {
    <div class="floating-menu">
        <button type="button"
            (click)="selectLanguage('es')"
            [class.active]="isActive()('es')"
            class="floating-lang-option"
        >
            🇪🇸 Español
        </button>
        <button type="button"
            (click)="selectLanguage('en')"
            [class.active]="isActive()('en')"
            class="floating-lang-option"
        >
            🇬🇧 English
        </button>
    </div>
    }
</div>
}
